import React, { useEffect } from 'react';

import { EventName } from '../../../services/analytics/providers/analyticsProvider';
import AnalyticsService from '../../../services/analytics/analyticsService';
import WelcomeFyxer from './Welcome/WelcomeFyxer';

export type FyxerOnboardingFlowProps = {
  // TODO
};

function FyxerOnboardingFlow(props: FyxerOnboardingFlowProps) {
  useEffect(() => {
    AnalyticsService.track(EventName.FYXER_GET_STARTED_VISIT);
  }, []);

  return <WelcomeFyxer />;
}

export default FyxerOnboardingFlow;
